import cx from 'classnames'
import type React from 'react'

import css from './AttachedFileWrapper.module.scss'

interface Props {
  selected: boolean
  children?: React.ReactNode
}
export const AttachedFileWrapper: React.FC<Props> = ({
  selected,
  children,
}) => {
  const className = cx(css.wrapper, { [css.selected]: selected })

  return (
    <div role="button" className={className}>
      {children}
    </div>
  )
}
